// Dates as the Dominican Republic writes them, on the Dominican calendar — the same rules as the backend's
// services/businessDay.js (see ECOSYSTEM.md §6 rule 11). The DR is UTC−4 all year.
//  - A bare date (a day picked in a form — a gasto's date, a vencimiento — stored as midnight UTC) is its own day.
//  - A real timestamp (createdAt, a payment's instant) is the Dominican day it falls in.
//  - Shown to people: DD/MM/AAAA. YYYY-MM-DD is only for inputs and the API.
export const TZ = 'America/Santo_Domingo';
const DAY_MS = 24 * 60 * 60 * 1000;

const ymd = (d, timeZone) => d.toLocaleDateString('en-CA', { timeZone }); // "2026-09-30"

// The calendar day a stored date stands for, "YYYY-MM-DD" (null for no / bad date).
export function calendarDay(date) {
  if (date === null || date === undefined || date === '') return null;
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  return ymd(d, d.getTime() % DAY_MS === 0 ? 'UTC' : TZ);
}

// Today in the DR, "YYYY-MM-DD" — for date inputs. Not toISOString(): that's UTC, already tomorrow after 8 p.m.
export const todayDR = () => ymd(new Date(), TZ);

// That many days from today (DR), "YYYY-MM-DD".
export const daysFromTodayDR = (days) => new Date(Date.parse(`${todayDR()}T12:00:00Z`) + days * DAY_MS).toISOString().slice(0, 10);

// The 1st of this month (DR), "YYYY-MM-DD".
export const firstOfMonthDR = () => `${todayDR().slice(0, 7)}-01`;

// "30/09/2026". `fallback` when there's no date.
export function formatDay(date, fallback = '—') {
  const day = calendarDay(date);
  return day ? day.split('-').reverse().join('/') : fallback;
}

// "30/09/2026 3:45 p. m." — a timestamp, Dominican time.
export function formatDateTime(date, fallback = '—') {
  if (date === null || date === undefined || date === '') return fallback;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return fallback;
  return `${formatDay(d)} ${d.toLocaleTimeString('es-DO', { timeZone: TZ, hour: 'numeric', minute: '2-digit' })}`;
}
